import { connector } from 'services/base';
import { IWhoAmIApiData } from './types';

// 公共-用户：当前用户信息
export async function getWhoAmI() {
  return connector.get<IWhoAmIApiData & { username: string }>(`/api/pti/user/who-am-i`);
}
